import PasswordInput from '../components/PasswordInput';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

const ChangePasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // バリデーション
    if (newPassword.length < 6) {
      setError('パスワードは6文字以上で入力してください');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }

    setIsLoading(true);

    try {
      // 現在のパスワードは一時パスワードなので、特別な処理が必要
      // ここでは空文字列を送信（バックエンド側でリセットフラグがある場合は現在のパスワードチェックをスキップ）
      await authService.changePassword({
        currentPassword: '', // リセット時は不要
        newPassword
      });

      // ユーザー情報を再取得してpasswordResetRequiredフラグを更新
      const updatedUser = await authService.getCurrentUser();
      authService.saveAuthData(authService.getAuthData().token!, updatedUser);

      // 成功したらダッシュボードへ
      navigate('/dashboard');
      window.location.reload(); // AuthContextを更新するためにリロード
    } catch (error: any) {
      setError(error.response?.data?.error || 'パスワード変更に失敗しました');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px' }}>
      <h1>パスワード変更</h1>

      <div style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '4px',
        padding: '15px',
        marginBottom: '20px'
      }}>
        <p style={{ margin: 0, color: '#856404' }}>
          <strong>一時パスワードでログインしています。</strong><br />
          セキュリティのため、新しいパスワードを設定してください。
        </p>
      </div>

      {error && (
        <div style={{
          color: 'red',
          marginBottom: '20px',
          padding: '10px',
          border: '1px solid red',
          borderRadius: '4px'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="newPassword">新しいパスワード:</label>
          <PasswordInput
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={6}
            placeholder="6文字以上"
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="confirmPassword">新しいパスワード（確認）:</label>
          <PasswordInput
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={6}
            placeholder="もう一度入力"
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: isLoading ? 'not-allowed' : 'pointer'
          }}
        >
          {isLoading ? '変更中...' : 'パスワードを変更'}
        </button>
      </form>
    </div>
  );
};

export default ChangePasswordPage;
